import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RateAuditComponent } from './rate-audit.component';
import { RaGridModule } from './ra-grid/ra-grid.module';
import { RateAuditRoutingModule} from './rate-audit-routing.module';
import{ ModalModule } from '../../common/component/modal/modal.module';

@NgModule({
  imports: [
    CommonModule
    ,RaGridModule
    ,RateAuditRoutingModule
    ,ModalModule
  ],
  declarations: [RateAuditComponent],
  exports: [RateAuditComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RateAuditModule { }


